<script lang="ts">
  import { X } from "lucide-svelte";
  import { onMount, onDestroy } from "svelte";
  import { cn } from "../lib/utils";

  export let open = false;
  export let title = "";
  export let onClose: () => void;
  let className = "";
  export { className as class };

  let previouslyFocused: HTMLElement | null = null;

  function handleKey(e: KeyboardEvent) {
    if (e.key === "Escape" && open) {
      e.stopPropagation();
      onClose();
    }
  }

  onMount(() => {
    window.addEventListener("keydown", handleKey);
  });
  onDestroy(() => {
    window.removeEventListener("keydown", handleKey);
  });

  $: if (typeof document !== "undefined") {
    if (open) {
      previouslyFocused = (document.activeElement as HTMLElement) || null;
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      previouslyFocused?.focus();
      previouslyFocused = null;
    }
  }
</script>

{#if open}
  <div class="fixed inset-0 z-40 flex items-end justify-center sm:items-center" role="dialog" aria-modal="true">
    <button
      type="button"
      aria-label="点击空白处关闭"
      tabindex="-1"
      class="absolute inset-0 bg-foreground/40 backdrop-blur-sm anim-fade-in-up"
      on:click={onClose}
    ></button>
    <div
      class={cn(
        "relative z-10 max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-t-3xl border border-foreground/10 bg-card shadow-2xl anim-fade-in-up sm:rounded-3xl",
        className
      )}
    >
      <header class="sticky top-0 z-10 flex items-center justify-between gap-3 border-b border-dashed border-foreground/10 bg-card/95 px-5 py-4 backdrop-blur">
        <h2 class="font-display text-lg leading-tight">{title}</h2>
        <button
          type="button"
          aria-label="关闭"
          class="focus-amber inline-flex size-8 items-center justify-center rounded-full text-muted-foreground hover:bg-foreground/5 hover:text-foreground"
          on:click={onClose}
        >
          <X class="size-4" />
        </button>
      </header>
      <div class="px-5 py-5">
        <slot />
      </div>
    </div>
  </div>
{/if}
